export const shouldPreloadMobilePages = () => {
  if (!("connection" in navigator)) return true;

  const { connection } = navigator;
  if (typeof connection !== "object" || connection === null) return true;

  const isSavingData = "saveData" in connection && connection.saveData === true;
  const isSlowConnection =
    "effectiveType" in connection &&
    (connection.effectiveType === "2g" ||
      connection.effectiveType === "slow-2g");

  return !isSavingData && !isSlowConnection;
};
